/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitFeedback} from '../api'

export const useMutationSubmitFeedback = createReactQueryMutationHook('submitFeedback', submitFeedback)
